const __DEV__ = false;

import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';

var _excluded = ["duration", "easing", "delay"];
var defaults = {
  linear: '80ms linear',
  easeinout: '150ms ease-in-out',
  standard: '200ms ease'
};
var easing = {
  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
var duration = {
  shortest: 150,
  shorter: 200,
  "short": 250,
  standard: 300,
  complex: 375,
  enteringScreen: 225,
  leavingScreen: 195,
  minimal: 50
};
function formatMs(milliseconds) {
  return "".concat(Math.round(milliseconds), "ms");
}
function create() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['all'];
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$duration = options.duration,
      durationOption = _options$duration === void 0 ? duration.standard : _options$duration,
      _options$easing = options.easing,
      easingOption = _options$easing === void 0 ? easing.easeInOut : _options$easing,
      _options$delay = options.delay,
      delay = _options$delay === void 0 ? 0 : _options$delay;
      _objectWithoutProperties(options, _excluded);
  return (Array.isArray(props) ? props : [props]).map(function (animatedProp) {
    return "".concat(animatedProp, " ").concat(typeof durationOption === 'string' ? durationOption : formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === 'string' ? delay : formatMs(delay));
  }).join(',');
}
function getAutoHeightDuration(height) {
  if (!height) {
    return 0;
  }
  var constant = height / 36;
  return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
}

export { create, defaults, duration, easing, getAutoHeightDuration };
//# sourceMappingURL=transitions.js.map
